module.exports = __webpack_public_path__ + "img/Pista_0119.a0840e98.png";